import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import Chat from 'vue-beautiful-chat'

Vue.use(VueAxios, axios)

Vue.use(Chat)
Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
